import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ByaHttp } from 'app/services/bya-http';
import { AuthService } from '@bya/auth/services/authentication.service';
import { Tercero } from 'app/main/datos-basicos/models/tercero';
@Injectable({
  providedIn: 'root'
})
export class EditarDatosPersonalesService extends ByaHttp {

	constructor
	(
		private http: HttpClient,
		protected dialog: MatDialog, 
		private _authService: AuthService
	) {
		super(dialog, _authService);
	}

	public GetTercero(): Observable<Tercero> {
		return this.http.get<Tercero>(`${this.baseUrl}api/User`)
		.pipe(
			tap(_ => this.log('fetched task')),
			catchError(this.handleError<Tercero>('OBTENER DATOS DEL TERCERO', null))
		);
	}

	public PutActualizarPerfil(tercero: Tercero): Observable<EditarDatosPersonalesResponse> {
		return this.http.put<EditarDatosPersonalesResponse>(`${this.baseUrl}api/User`, { tercero })
		.pipe(
			tap(_ => this.log('fetched task')),
			catchError(this.handleError<EditarDatosPersonalesResponse>('ACTUALIZAR DATOS DEL TERCERO', null))
		);
	}
}

export class EditarDatosPersonalesResponse{
	public error:boolean;
	public mensaje: string;
}